<script lang="ts">
export interface PhxsgVideoPlayerIframeProps {
  src: string;
  poster?: string | null;
}
</script>

<script setup lang="ts">
const { src, poster = null } = defineProps<PhxsgVideoPlayerIframeProps>();
</script>

<template>
  <iframe
    :src="src"
    :data-poster="poster ?? undefined"
    :autoplay="false"
    :muted="false"
    :loop="false"
    :playsinline="true"
    :controls="true"
    title="Embedded video"
    allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    allowtransparency
  />
</template>
